/**
 * buildReportIssueUrl — builds a GitHub "new issue" URL with the title and body
 * pre-filled for a learner reporting a problem from inside a module page.
 *
 * Pure (no DOM): the caller passes the current page URL, so this stays unit-testable.
 * v1 carries the module in the title prefix + body — NOT a label — because the repo
 * has no `module:*` labels and GitHub silently drops prefilled labels that don't exist.
 */

const GITHUB_REPO = process.env.REACT_APP_GITHUB_REPO || "drdgreed/career-foundry";

export interface ReportIssueContext {
  slug: string;
  moduleTitle?: string;
  pageUrl: string;
}

export function buildReportIssueUrl({ slug, moduleTitle, pageUrl }: ReportIssueContext): string {
  const title = `[${slug}] `;
  const body = [
    `**Module:** ${moduleTitle ?? slug} (\`${slug}\`)`,
    `**Page:** ${pageUrl}`,
    ``,
    `**What I was trying to do:**`,
    ``,
    `**What I expected:**`,
    ``,
    `**What actually happened:**`,
    ``,
    `---`,
    `_Filed from the in-app Report an issue button._`,
  ].join("\n");

  const params = new URLSearchParams({ title, body });
  return `https://github.com/${GITHUB_REPO}/issues/new?${params.toString()}`;
}
